import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RaiseUpdateInstallationDate from './raiseUpdateInstallationDate';
import SiteListing from '../siteListing';
import {
  getDetails,
} from 'services/redux/brandActivtion/sitesListing/action';
import {
  createInstallationDateChange,
  getInstallationDateChangeListing,
} from 'services/redux/installation/siteListing/action';
import { getContractDetails } from "services/redux/sales/preSaleListing/action"
import { documentUploadUrlPublic } from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
  documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
  viewDetails: state.preSalesListReducer.viewContract,
  installationDateChangeRequest:state.siteListingReducer.installationDateChangeRequest,
  installationDateChangeListing:state.siteListingReducer.installationDateChangeListing
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getContractDetails,
      createInstallationDateChange,
      getInstallationDateChangeListing,
      documentUploadUrlPublic
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(RaiseUpdateInstallationDate);
